/* globals
    Debug,
    LZString,
    xml2js,
    js2xml
*/

/* eslint-disable camelcase, new-cap */
if (! String.prototype.trim) {
    // eslint-disable-next-line no-extend-native
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
}

// eslint-disable-next-line no-unused-vars
function String_ToBoolean (str) {
    var result;

    str = str.toLowerCase();

    if (str === "1" || str.charAt(0) === "t") {
        result = true;
    }
    else if (str === "0" || str.charAt(0) === "f") {
        result = false;
    }
    else {
        Debug.AssertError("Value '" + str + "' can not be converted to a boolean.");
    }

    return result;
}

// private helper method for MergeQueryStringParameters()
function AddQueryStringParm (names, values, qsParm) {
    var equalsIndex = qsParm.indexOf("="),
        name,
        value;

    if (equalsIndex > -1) {
        name = qsParm.substr(0, equalsIndex);
        value = qsParm.substr(equalsIndex + 1);

        names[names.length] = name;
        values[values.length] = value;
    }
    else {
        // If it's just a name, add the parm as a property with a value of null
        names[names.length] = qsParm;
        values[values.length] = null;
    }
}

// accepts an arbitrary number of arguments and merges them into a single querystring
// eslint-disable-next-line no-unused-vars, complexity
function MergeQueryStringParameters () {
    var paramNames = [],
        paramValues = [],
        url = null,
        anchor = null,
        i,
        numOfNonEmptyArgs = 0,
        firstArg = null,
        qs,
        splitAtAnchor,
        urlPart,
        qsPart,
        allPairs,
        j,
        mergedQueryString = "",
        isFirstParm = true,
        value;

    for (i = 0; i < arguments.length; i += 1) {
        if (arguments[i] !== null && arguments[i].length > 0) {
            numOfNonEmptyArgs += 1;

            if (firstArg === null) {
                firstArg = arguments[i];
            }
        }
    }

    // Exit it by returning our one arg if that's all we have
    if (numOfNonEmptyArgs === 1) {
        return firstArg;
    }

    for (i = 0; i < arguments.length; i += 1) {
        qs = arguments[i] + "";

        // Pick off the anchor if it exists.
        // If the query string ends in a named anchor like "#middleofpage, save this
        // off and strip it from the url.  The first anchor seen will be the one used
        // in the merged query string.
        if (qs.indexOf("#") > -1) {
            if (qs.charAt(0) === "#") {
                if (anchor === null) {
                    anchor = qs.substring(1);
                }
                qs = "";
            }
            else {
                splitAtAnchor = qs.split("#");
                if (anchor === null) {
                    anchor = splitAtAnchor[1];
                }
                qs = splitAtAnchor[0];
            }
        }

        // Pick off the url if there is one
        if (qs.indexOf("?") > 0) {
            urlPart = qs.substring(0, qs.indexOf("?"));
            qsPart = qs.substring(qs.indexOf("?") + 1, qs.length);
            if (url === null) {
                url = urlPart;
            }
            qs = qsPart;
        }

        // If there's no ?, #, =, or &, assume it's a pure url
        // Since & can be a valid filename char, also check for the case where
        // there's a '&' but also a '.' which assumes there will be a filename extension in the url
        if (qs.indexOf("#") < 0
            && qs.indexOf("=") < 0
            && qs.indexOf("?") < 0
            && (qs.indexOf("&") < 0
                || (qs.indexOf("&") > 0 && qs.indexOf(".") > 0)
            )
        ) {
            if (url === null) {
                url = qs;
            }
            qs = "";
        }

        // May or may not be received with a "?" or "&" prefix so trim it off if it exists
        if (qs.charAt(0) === "?") {
            qs = qs.substring(1);
        }
        if (qs.charAt(0) === "&") {
            qs = qs.substring(1);
        }

        // Now get the params
        if (qs.indexOf("&") > -1) {
            allPairs = qs.split("&");
            for (j = 0; j < allPairs.length; j += 1) {
                AddQueryStringParm(paramNames, paramValues, allPairs[j]);
            }
        }
        else if (qs.length > 0) {
            AddQueryStringParm(paramNames, paramValues, qs);
        }
    }

    // Now contsruct the merged query string...
    if (url !== null) {
        mergedQueryString += url;
    }

    for (i = 0; i < paramNames.length; i += 1) {
        if (isFirstParm) {
            mergedQueryString += "?";
            isFirstParm = false;
        }
        else {
            mergedQueryString += "&";
        }

        mergedQueryString += paramNames[i];

        value = paramValues[i];

        // Some params may just have a name with no value, if so don't append "="
        if (value !== null) {
            mergedQueryString += "=" + value;
        }
    }

    if (anchor !== null) {
        mergedQueryString += "#" + anchor;
    }

    return mergedQueryString;
}

// eslint-disable-next-line no-unused-vars
function CleanExternalString (str) {
    // make sure the string is in a proper JS string format (who knows where it came from originally - Flash, Java, etc)
    // these transitions are enough to make absolutely sure that we have a native JavaScript string when we're done
    str += "";
    // eslint-disable-next-line no-new-wrappers
    str = new String(str);
    str = str.toString();

    // Strange, yes.  But it fixed an IE-specific corruption problem. (Seen specifically with interaction id)
    str = unescape(escape(str));

    return str;
}

// eslint-disable-next-line no-unused-vars
function ZeroPad (num, numDigits) {
    var strTemp = num + "",
        intLen = strTemp.length,
        i;

    if (intLen > numDigits) {
        strTemp = strTemp.substr(0, numDigits);
    }
    else {
        for (i = intLen; i < numDigits; i += 1) {
            strTemp = "0" + strTemp;
        }
    }

    return strTemp;
}

// rounds to the number of specified specified digits after the decimal point
// eslint-disable-next-line no-unused-vars
function RoundToPrecision (number, significantDigits) {
    return Math.round(number * Math.pow(10, significantDigits)) / Math.pow(10, significantDigits);
}

// eslint-disable-next-line no-unused-vars
function GetErrorDetailString (error) {
    var errParts = [];

    if (typeof navigator !== "undefined") {
        if (typeof navigator.userAgent !== "undefined") {
            errParts.push("User Agent: " + navigator.userAgent);
        }
        if (typeof navigator.platform !== "undefined") {
            errParts.push("Platform: " + navigator.platform);
        }
    }
    else {
        errParts.push("No browser information was available (via the global navigator object)");
    }

    if (typeof error.name !== "undefined") {
        errParts.push("Name: " + error.name);
    }
    if (typeof error.message !== "undefined") {
        errParts.push("Message: " + error.message);
    }
    if (typeof error.description !== "undefined") {
        errParts.push("Description: " + error.description);
    }
    if (typeof error.number !== "undefined") {
        errParts.push("Number: " + error.number);
    }
    if (typeof error.fileName !== "undefined") {
        errParts.push("Filename: " + error.fileName);
    }
    if (typeof error.lineNumber !== "undefined") {
        errParts.push("Linenumber: " + error.lineNumber);
    }
    if (typeof error.toString !== "undefined") {
        errParts.push("toString(): " + error.toString());
    }

    return errParts.join(", ");
}

function DoArraysMatch (arr1, arr2) {
    var i;

    if (arr1.length !== arr2.length) {
        return false;
    }

    for (i = 0; i < arr1.length; i += 1) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
}

// Support method to help compare current state of the registration. Used in determining
// what data is 'dirty' when using trimmed and compressed RecordResults payloads.
function CompareObj (diffs, item1, item2, key) {
    var type1 = Object.prototype.toString.call(item1),
        type2 = Object.prototype.toString.call(item2),
        objDiff,
        i,
        rtlDiff = [],
        rtlLogEntries = {};

    if (type2 === "[object Undefined]") {
        // This would happen if an property is dirty and then not dirty in subsequent
        // requests. It's not a difference to note in the diffs object.

        return;
    }

    // If items are different types
    if (type1 !== type2) {
        diffs[key] = item2;

        return;
    }

    // If an object, compare recursively
    if (type1 === "[object Object]") {
        // eslint-disable-next-line no-use-before-define
        objDiff = GenerateDiffObj(item1, item2);

        if (Object.keys(objDiff).length >= 1) {
            // The following two entries are special cases. Most of the runtime results properties are sequence
            // XML properties (for example: list of activities and shared data). If one entry of those properties
            // contains a diff, we need to add the whole entry to the diff, rather than just the diff itself.
            //
            // Consider an activity: If an activity's completion status changes, the GenerateDiffObj() method would only
            // record the changed completion status, but wouldn't include the activity id or other identifying
            // information, since it wouldn't have changed. With only a changed completionStatus, the server would have
            // trouble figuring out which activity the diff was associated with. Therefore, for any sequence entry that
            // has a changed property, the whole entry is considered a 'delta'.
            //
            // The run time log is a sequence property, but previous entries aren't altered by later payloads. Log
            // entries are simply added to the RTL. Therefore, we only want to include the diff with the payload.
            //
            // With the top level RTD property, we want to only include the diff. Otherwise, any time there was any
            // delta found within any of its properties, the entire payload would be considered the delta, which defeats
            // the purpose.
            if (key === "RTD" || key === "RTL") {
                diffs[key] = objDiff;
            }
            else {
                diffs[key] = item2;
            }
        }

        return;
    }

    // If an array, compare
    if (type1 === "[object Array]") {
        if (! DoArraysMatch(item1, item2)) {
            if (key === "RT") {
                // Handling for the Runtime log is a little different. The player isn't editing a
                // fixed number of entries (as it does for activities), it has entries added to it each
                // time a loggable event occurs. So, for most cases, the 'diffs' will be the recently
                // added log entries.
                for (i = 0; i < item1.length; i += 1) {
                    rtlLogEntries[item1[i]._attributes.id] = item1[i];
                }

                for (i = 0; i < item2.length; i += 1) {
                    // eslint-disable-next-line max-depth
                    if (! rtlLogEntries[item2[i]._attributes.id]) {
                        rtlDiff.push(item2[i]);
                    }

                    // This is a sanity check. It's not expected that a previous log entries
                    // would have been altered.
                    //
                    // eslint-disable-next-line no-use-before-define
                    else if (Object.keys(GenerateDiffObj(item1[i], item2[i])).length >= 1) {
                        rtlDiff.push(item2[i]);
                    }
                }

                diffs[key] = rtlDiff;
            }
            else if (item1.length !== item2.length) {
                diffs[key] = item2;
            }
            else {
                diffs[key] = [];
                // There must be an element that has changed. Note only the changed elements
                for (i = 0; i < item2.length; i += 1) {
                    // eslint-disable-next-line no-use-before-define
                    objDiff = GenerateDiffObj(item1[i], item2[i]);

                    // eslint-disable-next-line max-depth
                    if (Object.keys(objDiff).length >= 1) {
                        diffs[key].push(item2[i]);
                    }
                }
            }
        }

        return;
    }

    // At this point, we just have a primitive type, so we can compare values
    if (item1 !== item2) {
        diffs[key] = item2;
    }
}

// Support method to generate an object containing the 'diffs' between two objects. Used in generating
// trimmed 'dirty' data when using trimmed and compressed RecordResults payloads.
function GenerateDiffObj (obj1, obj2) {
    var diffs = {},
        key;

    if (! obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
        return obj1;
    }

    // Loop through properties in the first object and compare values to those in obj2
    for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            CompareObj(diffs, obj1[key], obj2[key], key);
        }
    }

    // Loop through the second object and add to diffs the properties that are missing from
    // obj1 and explicitly have a value in obj2.
    for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (typeof obj1[key] === "undefined" && (obj1[key] !== obj2[key])) {
                diffs[key] = obj2[key];
            }
        }
    }

    return diffs;
}

function PreserveInteractions (originalIntArray, update) {
    var updatedIntByIndexAttribute = {},
        updateIntArray,
        interactionsToAdd = [],
        i;

    if (update.ART) {
        if (update.ART.ARTI) {
            if (! update.ART.ARTI.length) {
                // fix up update to include interactions as an array, so they can be added to if needed
                update.ART.ARTI = [update.ART.ARTI];
            }
        }
        else {
            // update doesn't include any interactions, create array so it can be added to if needed
            update.ART.ARTI = [];
        }
        updateIntArray = update.ART.ARTI;
    }
    else {
        // nothing to do if there is no runtime update
        return;
    }

    // save reference to interactions in the update by interaction index
    for (i = 0; i < updateIntArray.length; i += 1) {
        updatedIntByIndexAttribute[updateIntArray[i]._attributes.I] = updateIntArray[i];
    }

    // check existing interactions to see if they are in update
    for (i = 0; i < originalIntArray.length; i += 1) {
        if (! updatedIntByIndexAttribute[originalIntArray[i]._attributes.I]) {
            // existing interaction in update, add it to update so when
            // state is updated it will be included
            interactionsToAdd.push(originalIntArray[i]);
        }
    }

    // add saved interactions to update
    for (i = 0; i < interactionsToAdd.length; i += 1) {
        updateIntArray.push(interactionsToAdd[i]);
    }
}

function RemoveMatchingInteractions (diffActivity, alreadySentActivity) {
    var findInteractions = function (json) {
            var actArr = json,
                act,
                i;

            if (! (actArr && actArr.length)) {
                act = actArr;
            }
            else {
                for (i = 0; i < actArr.length; i += 1) {
                    if (actArr[i].ART && actArr[i].ART.ARTI) {
                        act = actArr[i];
                    }
                }
            }
            if (act && act.ART && act.ART.ARTI) {
                if (! act.ART.ARTI.length) {
                    act.ART.ARTI = [act.ART.ARTI];
                }

                return act.ART.ARTI;
            }

            return [];
        },
        getInteractionIndexByIndexAttribute = function (interactionArray, indexAtt) {
            var i;

            for (i = 0; i < interactionArray.length; i += 1) {
                if (interactionArray[i]._attributes.I === indexAtt) {
                    return i;
                }
            }

            return null;
        },
        diffInt = findInteractions(diffActivity),
        sentInt = findInteractions(alreadySentActivity),
        i,
        matchIndex,
        diffObj;

    for (i = 0; i < sentInt.length; i += 1) {
        matchIndex = getInteractionIndexByIndexAttribute(diffInt, sentInt[i]._attributes.I);
        if (matchIndex !== null) {
            diffObj = GenerateDiffObj(sentInt[i], diffInt[matchIndex]);
            if (Object.keys(diffObj).length === 0) {
                // since the interaction to post back (in diffInt) has no differences from previously
                // posted interaction (in sentInt), remove it from diffInt so it will not
                // be sent again
                diffInt.splice(matchIndex, 1);
            }
        }
    }
}

// eslint-disable-next-line no-unused-vars
function UpdateObjectListProperty (lastStateProperty, updatedProperty, attributeKey) {
    var updatedPropertySet = {},
        checkForUpdates,
        propertyKey,
        i;

    if (typeof updatedProperty === "undefined") {
        return;
    }

    // Organize the set of updated properties. Loop through the list of updated values,
    // and store them using the 'attributeKey' as the key.
    for (i = 0; i < updatedProperty.length; i += 1) {
        propertyKey = updatedProperty[i]._attributes[attributeKey];
        updatedPropertySet[propertyKey] = updatedProperty[i];
    }

    // Loop through the property in the 'LastState' object. If the property has a
    // corresponding entry in the 'updatedPropertySet', then update the property
    // in the LastState object.
    for (i = 0; i < lastStateProperty.length; i += 1) {
        checkForUpdates = lastStateProperty[i]._attributes[attributeKey];
        if (updatedPropertySet[checkForUpdates]) {
            if (lastStateProperty[i].ART && lastStateProperty[i].ART.ARTI) {
                // last state includes interactions, preserve any that are
                // not being updated by including them in "updatedProperty"
                PreserveInteractions(
                    lastStateProperty[i].ART.ARTI,
                    updatedPropertySet[checkForUpdates]
                );
            }
            lastStateProperty[i] = updatedPropertySet[checkForUpdates];
        }
    }
}

if (! String.prototype.repeat) {
    // eslint-disable-next-line no-extend-native
    String.prototype.repeat = function (times) {
        if (times < 0) {
            // eslint-disable-next-line no-throw-literal
            throw "Cannot repeat a string less than zero times";
        }

        return new Array(times + 1).join(this);
    };
}

if (! String.prototype.leftpad) {
    // eslint-disable-next-line no-extend-native
    String.prototype.leftpad = function (padChar, newLength) {
        if (padChar.length !== 1) {
            // eslint-disable-next-line no-throw-literal
            throw "Must pad string with character of length 1";
        }

        if (this.length >= newLength) {
            return this;
        }

        return padChar.repeat(newLength - this.length) + this;
    };
}

// eslint-disable-next-line no-unused-vars
function GetUpdatedLastState (lastState, postedData, compressionIndicatorToken) {
    var postedXmlData,
        updatedObj,
        runtimeLogDiff,
        activitiesArray,
        i;

    if (postedData.indexOf(compressionIndicatorToken) === 0) {
        // Remove the prefix that indicates that the data has been compressed,
        // and then decompress the data
        postedXmlData = LZString.decompressFromBase64(postedData.substring(compressionIndicatorToken.length));
    }
    else {
        postedXmlData = postedData;
    }

    if (lastState === null) {
        return xml2js(
            postedXmlData,
            {
                compact: true
            }
        );
    }

    // At this point, we have two objects. We have the recently posted 'postedXMLData' and
    // we also have lastState. Compare the two and update the LastState.
    updatedObj = xml2js(
        postedXmlData,
        {
            compact: true
        }
    );

    // If there is only one changed activity posted back, updatedObj.RTD.A
    // will not be parsed as an array. Fix it to be a single-element
    // array so UpdateObjectListProperty can work as expected
    activitiesArray = updatedObj.RTD.A;
    if (Object.prototype.toString.call(activitiesArray) === "[object Object]") {
        activitiesArray = [activitiesArray];
    }

    // Activities, use the "Database Identifier" as key
    UpdateObjectListProperty(lastState.RTD.A, activitiesArray, "DI");

    // Global Objectives, use the "Registration Objective Id" as key
    UpdateObjectListProperty(lastState.RTD.GO, updatedObj.RTD.GO, "ROI");

    // SSPBuckets, use the "ID" property as key
    UpdateObjectListProperty(lastState.RTD.SSP, updatedObj.RTD.SSP, "ID");

    // Shared Data, use the "SharedDataValId" property as key
    UpdateObjectListProperty(lastState.RTD.SD, updatedObj.RTD.SD, "SDVI");

    // Runtime State
    if (typeof updatedObj.RTD.RS !== "undefined") {
        if (JSON.stringify(GenerateDiffObj(lastState.RTD.RS, updatedObj.RTD.RS)) !== "{}") {
            Object.assign(lastState.RTD.RS._attributes, updatedObj.RTD.RS._attributes);
        }
    }

    // Runtime Log
    if (typeof updatedObj.RTD.RTL !== "undefined") {
        runtimeLogDiff = GenerateDiffObj(lastState.RTD.RTL, updatedObj.RTD.RTL);

        if (JSON.stringify(runtimeLogDiff) !== "{}") {
            if (runtimeLogDiff._attributes) {
                Object.assign(lastState.RTD.RTL._attributes, updatedObj.RTD.RTL._attributes);
            }

            if (runtimeLogDiff.RT) {
                if (typeof lastState.RTD.RTL.RT === "undefined") {
                    lastState.RTD.RTL.RT = [];
                }
                for (i = 0; i < runtimeLogDiff.RT.length; i += 1) {
                    lastState.RTD.RTL.RT.push(runtimeLogDiff.RT[i]);
                }
            }
        }
    }

    return lastState;
}

// eslint-disable-next-line no-unused-vars
function BuildXmlForDirtyData (lastState, xmlRequestPayload, runtimeAttributes, xmlEncodeFunction) {
    var jsonRequestPayload,
        deltaData,
        deltaXML;

    // Generate an XML of the delta. We have 'LastState' and we have the XML data that was generated to send with the
    // 'RecordResults' request. Diff these data sets so that we only send what is necessary.

    // Convert the XML to JSON to make comparisons simpler
    jsonRequestPayload = xml2js(
        xmlRequestPayload,
        {
            compact: true
        }
    );

    deltaData = GenerateDiffObj(lastState, jsonRequestPayload);

    // special handling for interactions: if activity is changed at all
    // deltaData will include complete set of interactions,
    // remove any that are unchanged
    RemoveMatchingInteractions(deltaData.RTD.A, lastState.RTD.A);

    deltaData.RTD._attributes = runtimeAttributes;

    deltaXML = js2xml(
        deltaData,
        {
            compact: true,
            ignoreComment: true,
            spaces: 4,

            // There is some inconsistency in how special characters are encoded between the xml and js handling
            // of the xml-js tool. This has to do with a dependency of xml-js itself. To check against this, we
            // need to re-encode attribute values.
            //
            // Since we already have code to encode attribute values used when we write XML manualy, using that here
            //
            // For more info, see: https://github.com/nashwaan/xml-js/issues/26
            attributeValueFn: xmlEncodeFunction
        }
    );

    return deltaXML;
}

// Polyfill for the Object.assign method, which is not supported in IE. Used in generating compressed,
// delta data for RecordResults
/* eslint-disable */
if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }

            return to;
        },
        writable: true,
        configurable: true
    });
}